import {
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Cancel, NotificationsActive, Update } from "@material-ui/icons";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  AutocompleteInput,
  BooleanInput,
  Button,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { RemoveReasonType } from "../../../../Enums/RemoveReasonType";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { RequestType } from "../../../../Enums/RequestType";
import { UnserviceableStatu } from "../../../../Enums/UnserviceableStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { SourceRequestOrder } from "../../Constant/Source";
import { RequestUnserviceablePutModel } from "../../Models/RequestUnserviceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import UnserviceableStatusChip from "../Statu/UnserviceableStatusChip";
import RemoveReasonSubType from "./RemoveReasonSubTypeComponent";
import { RequestFileType } from "../../../../Enums/RequestFileType";
import { UnscheduledRemoveReasonSubType } from "../../../../Enums/RemoveReasonSubType";
import { RemovalTransactionTypeChoices } from "../../../../Enums/RemovalTransactionType";
import { formatDate } from "../../../../Helper/MomentHelper";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const UnserviceableUpdate = props => {
  const [loading, setLoading] = useState(false);
  const [unserviceableFormDisabled, setUnserviceableFromDisabled] = useState(true);
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const { user } = useAuth();
  const [isButtonShow, setIsAButtonShow] = useState(props.unserviceable?.status !== UnserviceableStatu.Offered);
  const [requestHistory, setRequestHistory] = useState<any>({} as any);
  const [open, setOpen] = React.useState(false);
  const [refNoList, setRefNoList] = useState<any[]>([]);
  const [customerACList, setCustomerACList] = useState<any[]>([]);
  const classes = useStyles();
  const dataProvider = useAppDataProvider();
  const provider = useDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { canPerform: canEditOnlyShow } = useAccessControl(SourceRequestOrder, "editonlyshow");
  const requestId = props.requestId;
  const requestDetail = props?.requestDetail;
  let formRef: any = null;

  useEffect(() => {
    setIsAButtonShow(props.unserviceable?.status !== UnserviceableStatu.Offered);
    getSendShippingDetails();
    formRef.change("removeFromAc", requestDetail?.aircraftId);
    formRef.change("rejectedAircraftId", props.unserviceable?.rejectedAircraftId);
    formRef.change("rejectedRefNo", props.unserviceable?.rejectedRefNo);
  }, [props.unserviceable]);
  useEffect(() => {
    if (requestDetail) {
      GetRefNoList();
      GetCustomerACList();
    }
  }, [requestDetail]);
  const GetRefNoList = () => {
    dataProvider
      .getList("requestorders/getlistbycustomercode", {
        filter: {},
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "DESC" },
      })
      .then(res => {
        setRefNoList(res?.data || []);
      });
  };
  const GetCustomerACList = () => {
    dataProvider
      .getList("cdmaircraft", {
        filter: {
          contractNumber__eq: requestDetail?.contractId ?? 0,
        },
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "DESC" },
      })
      .then(res => {
        if (res?.data.length > 0) {
          let list = res?.data;
          list.push({ acReg: "REJECTION", id: -1 });
          list = list.sort((a, b) => (a.id > b.id ? 1 : -1));
          setCustomerACList(list);
        } else {
          setCustomerACList([]);
        }
      });
  };
  const getSendShippingDetails = async () => {
    const { data } = await provider.getList("requesthistorys", {
      pagination: { page: 1, perPage: 10 },
      sort: { field: "createdDate", order: "DESC" },
      filter: {
        requestId__eq: props.requestId,
        requestStatus__eq: RequestStatus.SendShippingDetails,
      },
    });

    if (data?.length > 0) {
      setRequestHistory(data[0]);
    }
  };
  const UpdateUnserviceableButtonClick = e => {
    UpdateUnserviceable(e);
  };
  const UpdateUnserviceable = e => {
    let requestUnserviceableUpdateModel: RequestUnserviceablePutModel = new RequestUnserviceablePutModel();
    requestUnserviceableUpdateModel.id = props.unserviceable.id;
    requestUnserviceableUpdateModel.RequestId = props.unserviceable.requestId;
    requestUnserviceableUpdateModel.Status = props.unserviceable.status;
    requestUnserviceableUpdateModel.SubmittedBy = props.unserviceable.submittedBy;
    requestUnserviceableUpdateModel.SubmittedDate = props.unserviceable.submittedDate;
    requestUnserviceableUpdateModel.RemoveReasonRemark = e.unserviceableRemoveReasonRemark;
    requestUnserviceableUpdateModel.SendTypeId = e.unserviceableSendTypeId;
    requestUnserviceableUpdateModel.Awb = e.unserviceableAwb;
    requestUnserviceableUpdateModel.CarrierEnum = e.unserviceableCarrierEnum;
    requestUnserviceableUpdateModel.EstimatedDeliveryDate = e.unserviceableEstimatedDeliveryDate;
    requestUnserviceableUpdateModel.FlightDate = e.unserviceableFlightDate;
    requestUnserviceableUpdateModel.FlightNo = e.unserviceableFlightNo;
    requestUnserviceableUpdateModel.IsWarranty = e.isWarranty;
    requestUnserviceableUpdateModel.RemoveDateFromAc = e.unserviceableRemoveDateFromAc;
    requestUnserviceableUpdateModel.RemoveReasonSubCategory = e.unserviceableRemoveReasonSubCategory;
    requestUnserviceableUpdateModel.RemoveReasonSubType = e.removeReasonSubType;
    requestUnserviceableUpdateModel.RemoveReasonType = e.removeReasonType;
    requestUnserviceableUpdateModel.SendTypeId = e.unserviceableSendTypeId;
    requestUnserviceableUpdateModel.AirportCode = e.unserviceableAirportCode;
    requestUnserviceableUpdateModel.Pn = e.unserviceablePn;
    requestUnserviceableUpdateModel.Sn = e.unserviceableSn;
    requestUnserviceableUpdateModel.Csi = e.unserviceableCsi;
    requestUnserviceableUpdateModel.Csn = e.unserviceableCsn;
    requestUnserviceableUpdateModel.Cso = e.unserviceableCso;
    requestUnserviceableUpdateModel.Csr = e.unserviceableCsr;
    requestUnserviceableUpdateModel.Dsi = e.unserviceableDsi;
    requestUnserviceableUpdateModel.Dsn = e.unserviceableDsn;
    requestUnserviceableUpdateModel.Dso = e.unserviceableDso;
    requestUnserviceableUpdateModel.Tsi = e.unserviceableTsi;
    requestUnserviceableUpdateModel.Tso = e.unserviceableTso;
    requestUnserviceableUpdateModel.Tsn = e.unserviceableTsn;
    requestUnserviceableUpdateModel.Tsr = e.unserviceableTsr;
    requestUnserviceableUpdateModel.Remark = e.remark;
    requestUnserviceableUpdateModel.updatedBy = user?.employeeId;
    requestUnserviceableUpdateModel.updatedDate = new Date();
    requestUnserviceableUpdateModel.RemoveFromAc = e.removeFromAc.toString();
    requestUnserviceableUpdateModel.RejectedAircraftId = e.rejectedAircraftId;
    requestUnserviceableUpdateModel.RejectedRefNo = e.rejectedRefNo;
    requestUnserviceableUpdateModel.IsRejected = e.isRejected;
    requestUnserviceableUpdateModel.PnDifferenceReasonRemark = e.pnDifferenceReasonRemark;
    requestUnserviceableUpdateModel.Batch = e.batch;
    requestUnserviceableUpdateModel.RemovalTransactionType = e.removalTransactionType;
    requestUnserviceableUpdateModel.EngineSerialNumber = e.engineSerialNumber;

    if (PnDifferenceValidation(requestUnserviceableUpdateModel)) {
      setOpen(true);
      return;
    }
    setLoading(true);
    PutUnserviceable(requestUnserviceableUpdateModel);
  };

  const PnDifferenceValidation = (requestUnserviceablePutModel: RequestUnserviceablePutModel) => {
    if (
      requestUnserviceablePutModel.Pn !== requestDetail.customerRequestComponent &&
      (requestUnserviceablePutModel.PnDifferenceReasonRemark === null ||
        requestUnserviceablePutModel.PnDifferenceReasonRemark === undefined ||
        requestUnserviceablePutModel.PnDifferenceReasonRemark === "")
    ) {
      return true;
    }

    return false;
  };

  const PutUnserviceable = async (requestUnserviceablePutModel: RequestUnserviceablePutModel) => {
    dataProvider
      .putRequestUnserviceable(requestUnserviceablePutModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        history.push("/requestorders/" + requestId + "/2");
        setIsAButtonShow(true);
        setApproveButtonShown(false);
        setUnserviceableFromDisabled(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const AcceptOrRejectButtonClick = (unserviceable, isApproved) => e => {
    AcceptOrRejectServiceable(unserviceable, isApproved);
  };
  const AcceptOrRejectServiceable = async (unserviceable, isApproved) => {
    let requestUnserviceableUpdateModel: RequestUnserviceablePutModel;

    requestUnserviceableUpdateModel = { ...unserviceable };
    requestUnserviceableUpdateModel.Status =
      isApproved === true ? UnserviceableStatu.Accepted : UnserviceableStatu.Rejected;
    requestUnserviceableUpdateModel.updatedBy = user?.employeeId;
    requestUnserviceableUpdateModel.updatedDate = new Date();

    dataProvider
      .putRequestUnserviceable(requestUnserviceableUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        setIsAButtonShow(true);
        history.push("/requestorders/" + requestId + "/2");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const openEditableFields = e => {
    setApproveButtonShown(true);
    setUnserviceableFromDisabled(false);
  };

  const cancelUpdate = e => {
    setApproveButtonShown(false);
    setUnserviceableFromDisabled(true);
  };
  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  const IncludeQuarantineButtonClick = requestDetailData => e => {
    IncludeQuarantineProcess(requestDetailData);
  };

  const IncludeQuarantineProcess = requestOrder => {
    history.push({
      pathname: `/quarantines/create/`,
      state: { refNo: requestOrder?.refNo },
    });
  };

  const WarningDialog = () => {
    const handleClose = () => setOpen(false);

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{"Cannot be registered"}</DialogTitle>
        <Divider />
        <DialogContent>
          <div>If two pns are different from each other, the Pn Difference Reason Remark field must be filled.</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} label="Close" />
        </DialogActions>
      </Dialog>
    );
  };

  const IsUpdate = values => {
    if (!user?.isCustomer) return true;

    const isUsTagExist =
      (props?.requestDetail?.requestOrderFiles?.filter?.(
        x =>
          x.requestFileTypeGroupEnum === RequestFileType.Unserviceable &&
          x.requestFileTypeEnum === RequestFileType.UsTag
      )?.length ?? 0) > 0;

    //Reliability US TAG file check if FoF
    if (
      values.removeReasonType === RemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
    ) {
      if (!isUsTagExist) return false;
      if (values.tsi !== 0) return false;
    }

    if (
      values.removeReasonType === RemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure
    ) {
      if (!isUsTagExist) return false;
      if (values.tsi === 0 || values.tsi > 30000) return false;
    }

    return true;
  };

  return (
    <>
      <Form
        onSubmit={UpdateUnserviceableButtonClick}
        render={({ handleSubmit, form, values }) => {
          formRef = form;
          return (
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <SectionTitle label="Shipment Info" />
                      <UnserviceableStatusChip unserviceable={props.unserviceable} />
                      {requestHistory?.id > 0 && (
                        <Chip
                          key={requestHistory?.id}
                          color="primary"
                          variant="outlined"
                          label={`Notified Date ${
                            requestHistory?.createdDate != null
                              ? props?.unserviceable?.updatedDate != null &&
                                props.unserviceable.updatedDate > requestHistory?.createdDate
                                ? formatDate(props.unserviceable.updatedDate)
                                : formatDate(requestHistory.createdDate)
                              : ""
                          }`}
                          icon={<NotificationsActive />}
                        />
                      )}
                    </Grid>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <BooleanInput
                          label="Rejection"
                          source="isRejected"
                          defaultValue={props.unserviceable?.isRejected}
                          disabled={unserviceableFormDisabled}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <BooleanInput
                          label="Warranty"
                          source="isWarranty"
                          defaultValue={props.unserviceable?.isWarranty}
                          disabled={unserviceableFormDisabled}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                    {values.isRejected === true && (
                      <>
                        <Separator />
                        <Grid {...gridContainerProps}>
                          <SectionTitle label="REJECTION" />
                        </Grid>
                        <Separator />
                        <Grid {...gridContainerProps}>
                          <Grid item xs={12} sm={5}>
                            <SelectInput
                              label="Rejection AC"
                              source="rejectedAircraftId"
                              optionText="acReg"
                              optionValue="id"
                              variant="outlined"
                              choices={customerACList}
                              fullWidth
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs={12} sm={5}>
                            <SelectInput
                              label="Rejection Ref No"
                              source="rejectedRefNo"
                              optionText="refNo"
                              optionValue="refNo"
                              variant="outlined"
                              choices={refNoList}
                              fullWidth
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Separator />
                      </>
                    )}
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <SectionTitle label="Component Info" />
                    </Grid>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="unserviceablePn"
                          label="Part Number"
                          fullWidth
                          variant="outlined"
                          defaultValue={props.unserviceable?.pn}
                          disabled={unserviceableFormDisabled}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="unserviceableSn"
                          label="Serial Number"
                          fullWidth
                          variant="outlined"
                          defaultValue={props.unserviceable?.sn}
                          disabled={unserviceableFormDisabled}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        {props?.requestDetail?.requestStatus == RequestStatus.WaitingShippingDetails && (
                          <TextInput
                            source="unserviceableAwb"
                            label="AWB"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.awb}
                            disabled={unserviceableFormDisabled}
                            validate={required()}
                          />
                        )}
                        {props?.requestDetail?.requestStatus != RequestStatus.WaitingShippingDetails && (
                          <TextInput
                            source="unserviceableAwb"
                            label="AWB"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.awb}
                            disabled={unserviceableFormDisabled}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="unserviceableFlightNo"
                          label="Flight No"
                          fullWidth
                          variant="outlined"
                          defaultValue={props.unserviceable?.flightNo}
                          disabled={unserviceableFormDisabled}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="unserviceableRemoveReasonRemark"
                          label="Remove Reason"
                          multiline
                          resettable
                          fullWidth
                          rows={4}
                          variant="outlined"
                          defaultValue={props.unserviceable?.removeReasonRemark}
                          disabled={unserviceableFormDisabled}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <CustomDatetime
                          fullWidth
                          defaultValue={props.unserviceable?.removeDateFromAc}
                          disabled={unserviceableFormDisabled}
                          source="unserviceableRemoveDateFromAc"
                          label="Remove Date from AC"
                          inputVariant={"dialog"}
                          variant="outlined"
                          maxDate={values.unserviceableFlightDate}
                          minDate={values.unserviceableFlightDate}
                          validate={[required(), maxValue(values.unserviceableFlightDate)]}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        {requestDetail?.requestType === RequestType.RBH ? (
                          <CustomDatetime
                            fullWidth
                            defaultValue={props.unserviceable?.flightDate}
                            disabled={unserviceableFormDisabled}
                            source="unserviceableFlightDate"
                            label="Flight Date"
                            inputVariant={"dialog"}
                            variant="outlined"
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />
                        ) : (
                          <CustomDatetime
                            fullWidth
                            defaultValue={props.unserviceable?.flightDate}
                            disabled={unserviceableFormDisabled}
                            source="unserviceableFlightDate"
                            label="Flight Date"
                            inputVariant={"dialog"}
                            variant="outlined"
                            validate={[required()]}
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={5}></Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        {props?.requestDetail?.requestStatus == RequestStatus.WaitingShippingDetails && (
                          <SelectInput
                            source="unserviceableCarrierEnum"
                            label="Carrier Type"
                            choices={GetCarrierType}
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.carrierEnum}
                            disabled={unserviceableFormDisabled}
                            validate={required()}
                          />
                        )}
                        {props?.requestDetail?.requestStatus != RequestStatus.WaitingShippingDetails && (
                          <SelectInput
                            source="unserviceableCarrierEnum"
                            label="Carrier Type"
                            choices={GetCarrierType}
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.carrierEnum}
                            disabled={unserviceableFormDisabled}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <CustomDatetime
                          defaultValue={props.unserviceable?.estimatedDeliveryDate}
                          disabled={unserviceableFormDisabled}
                          fullWidth
                          source="unserviceableEstimatedDeliveryDate"
                          label="Estimated Delivery Date"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          minDate={values.unserviceableFlightDate}
                          validate={minValue(values.unserviceableFlightDate)}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <Grid item xs={12} sm={5}></Grid>
                        <RemoveReasonSubType
                          isDisabled={unserviceableFormDisabled}
                          removeReasonType={props.unserviceable?.removeReasonType}
                          removeReasonSubType={props.unserviceable?.removeReasonSubType}
                        />
                        <TextInput
                          source="unserviceableRemoveReasonSubCategory"
                          label="Remove Reason Sub Category"
                          multiline
                          resettable
                          fullWidth
                          rows={4}
                          variant="outlined"
                          defaultValue={props.unserviceable?.removeReasonSubCategory}
                          disabled={unserviceableFormDisabled}
                        />
                        <ReferenceInput
                          label="Remove From AC"
                          source="removeFromAc"
                          reference="cdmaircraft"
                          perPage={9999}
                          translateChoice={false}
                          filter={{
                            contractNumber__eq: props.requestDetail?.contractId,
                          }}
                        >
                          <SelectInput
                            optionText="acReg"
                            optionValue="id"
                            variant="outlined"
                            defaultValue={props.requestDetail?.aircraftId}
                            fullWidth
                            disabled
                          />
                        </ReferenceInput>
                        <ReferenceInput
                          label="Airport Code"
                          source="unserviceableAirportCode"
                          reference="cdmlocations"
                          translateChoice={false}
                          defaultValue={props.unserviceable?.airportCode}
                          filterToQuery={searchText => ({
                            id__contains: searchText,
                          })}
                          sort={{ field: "id", order: "ASC" }}
                        >
                          <AutocompleteInput
                            optionText="id"
                            optionValue="id"
                            variant="outlined"
                            resettable
                            fullWidth
                            disabled={unserviceableFormDisabled}
                          />
                        </ReferenceInput>
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="remark"
                          label="Remarks of Customer"
                          multiline
                          resettable
                          fullWidth
                          disabled={unserviceableFormDisabled}
                          defaultValue={props.unserviceable?.remark}
                          rows={4}
                          variant="outlined"
                          FormHelperTextProps={{
                            style: { display: "block" },
                          }}
                          helperText="If any, remarks about the core unit itself should be explained such as ‘Fail on fit, deep dive required’"
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}></Grid>
                      <Grid item xs={12} sm={5}></Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid {...gridContainerProps} spacing={0} sm={5} justify="space-between">
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableTso"
                            label="TSO (Hour)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.tso}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableCso"
                            label="CSO (Cycle)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.cso}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <NumberInput
                            source="unserviceableDso"
                            label="DSO (Days)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.dso}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="pnDifferenceReasonRemark"
                          label="Pn Difference Reason Remark"
                          multiline
                          resettable
                          fullWidth
                          disabled={unserviceableFormDisabled}
                          defaultValue={props.unserviceable?.pnDifferenceReasonRemark}
                          rows={4}
                          variant="outlined"
                          FormHelperTextProps={{
                            style: { display: "block" },
                          }}
                          helperText="If request pn is different than unserviceable pn, please enter remark of reason."
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid {...gridContainerProps} spacing={0} sm={5} justify="space-between">
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableTsr"
                            label="TSR (Hour)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.tsr}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableCsr"
                            label="CSR (Cycle)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.csr}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3} />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <NumberInput
                          source="batch"
                          label="Batch"
                          fullWidth
                          variant="outlined"
                          defaultValue={props.unserviceable?.batch}
                          disabled={unserviceableFormDisabled}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid {...gridContainerProps} spacing={0} sm={5} justify="space-between">
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableTsn"
                            label="TSN (Hour)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.tsn}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableCsn"
                            label="CSN (Cycle)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.csn}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableDsn"
                            label="DSN (Days)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.dsn}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <SelectInput
                          source="removalTransactionType"
                          optionValue="Value"
                          optionText="Description"
                          fullWidth
                          variant="outlined"
                          choices={RemovalTransactionTypeChoices}
                          defaultValue={props.unserviceable?.removalTransactionType}
                          disabled={unserviceableFormDisabled}
                          allowEmpty
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="engineSerialNumber"
                          label="Engine Serial Number"
                          fullWidth
                          resettable
                          variant="outlined"
                          defaultValue={props.unserviceable?.engineSerialNumber}
                          disabled={unserviceableFormDisabled}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid {...gridContainerProps} spacing={0} sm={5} justify="space-between">
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableTsi"
                            label="TSI (Days)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.tsi}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableCsi"
                            label="CSI (Days)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.csi}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <NumberInput
                            source="unserviceableDsi"
                            label="DSI (Days)"
                            fullWidth
                            variant="outlined"
                            defaultValue={props.unserviceable?.dsi}
                            disabled={unserviceableFormDisabled}
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sm={5} />
                    </Grid>

                    <Separator />
                    <Toolbar {...props} placeholder="" classes={classes}>
                      {approveButtonShown === false &&
                        props?.requestDetail?.requestStatus != (RequestStatus.Shipped as any) && (
                          <>
                            <Button
                              label="Edit Core Unit"
                              disabled={loading}
                              size="medium"
                              variant="contained"
                              onClick={openEditableFields}
                              style={{ margin: "8px", background: "#ffc107" }}
                            >
                              {<Update />}
                            </Button>
                          </>
                        )}

                      {approveButtonShown === true && (
                        <>
                          <Button
                            label={loading ? "Core Unit is updating!" : "Update Core Unit"}
                            disabled={loading}
                            size="medium"
                            variant="contained"
                            onClick={handleSubmit}
                            style={{
                              margin: "8px",
                              background: "#ffc107 !important",
                            }}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                          </Button>
                          <Button
                            label={loading ? "Cancel!" : "Cancel "}
                            disabled={loading}
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={cancelUpdate}
                            style={{ margin: "8px" }}
                          >
                            {<Cancel />}
                          </Button>
                        </>
                      )}

                      {/* <>
                        {false && (
                          <Button
                            label={loading ? "Being Quarantined!" : "Include in Quarantine"}
                            disabled={loading ? true : !IsUpdate(values)}
                            size="medium"
                            variant="contained"
                            onClick={IncludeQuarantineButtonClick(props.requestDetail)}
                            style={{
                              margin: "8px",
                              background: "rgb(255, 193, 7)",
                            }}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                          </Button>
                        )}
                      </> */}
                    </Toolbar>
                  </>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
      <WarningDialog />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Unserviceable} />
    </>
  );
};

const RbhRequestUnserviceableUpdate = props => {
  return (
    <UnserviceableUpdate
      unserviceable={props.requestDetail?.requestUnserviceable}
      requestDetail={props.requestDetail}
      requestId={props.requestId}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default RbhRequestUnserviceableUpdate;
